module.exports = __webpack_public_path__ + "img/kidspoint.0ea8e29c.jpg";